import PropTypes from 'prop-types'
import { styled } from 'styled-components'
import i18next from 'common-ui-components/src/vtj/i18next'
import colors from 'common-ui-components/src/vtj/theme/colors'
import Icon from 'common-ui-components/src/vtj/icon/Icon.react'

// Bootstrap .sr-only
// Not extending from NonVisibleStyles because in some cases that causes some
// screen readers to read the content one letter at a time.
/**
 * @deprecated Use SFI design system VisuallyHidden instead.
 * @see https://vrk-kpa.github.io/suomifi-ui-components/#/Components/VisuallyHidden
 */
const ScreenReaderOnly = styled.span`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
`

export const A = styled.a`
  &:visited {
    ${Icon} use {
      &[*|href$='#icon-external-link2'],
      &[*|href$='#icon-import'] {
        fill: ${colors.visitedLinkColor};
      }
    }
  }
`

/**
 * @deprecated Use SFI design system ExternalLink instead.
 * @see https://vrk-kpa.github.io/suomifi-ui-components/#/Components/Link?id=external-link
 */
const ExternalLink = ({ href, target, rel, lang, children, ...rest }) => {
  const translate = i18next.getFixedT(lang)
  return (
    <A href={href} target="_blank" rel="noopener noreferrer" {...rest}>
      {children}
      <ScreenReaderOnly>{`(${translate(
        'opensInNewWindow'
      )})`}</ScreenReaderOnly>
    </A>
  )
}

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
}

/**
 * @deprecated Use SFI design system ExternalLink instead.
 * @see https://vrk-kpa.github.io/suomifi-ui-components/#/Components/Link?id=external-link
 */
export default ExternalLink
